import { ReactiveMap } from '@slicesjs/react-core';

import {
  RegistrationScheduleSharedMapContext,
  RegistrationScheduleSharedState,
} from './types';

export const createReactiveMap = (onError?: (error: Error) => void) => {
  const reactiveMap = new ReactiveMap<
    RegistrationScheduleSharedState,
    RegistrationScheduleSharedMapContext
  >({
    onError,
    allowedKeys: [
      'selectedSegmentExternalIds',
      'bookASeatEnabled',
      'ticketExternalId',
      'registrationAccessType',
    ],
  });

  reactiveMap.item('selectedSegmentExternalIds', { initialiser: () => [] });
  reactiveMap.item('bookASeatEnabled', { initialiser: () => false });
  reactiveMap.item('ticketExternalId', {
    initialiser: () => null,
  });
  reactiveMap.item('registrationAccessType', {
    initialiser: () => null,
  });

  return reactiveMap;
};
